import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 4 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 8\" id=\"arrow-right\"><path d=\"M4 4 0 8V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol